import { Session } from "@multicines/types";
import { CINEMARK_TICKETS_VENDOR, sortByDate } from "@multicines/utils";
import dayjs from "dayjs";
import React, { useCallback, useMemo } from "react";

import Styles from "./TheaterType.styles";
import { SessionPartial, TheaterTypeProps as Props } from "./TheaterType.types";
import ScheduleSession from "../ScheduleSession/ScheduleSession";
import { useStoresStore } from "stores/stores/stores.store";

const empty = "-999";

const TheaterType: React.FC<Props> = props => {
  const { className, theaterType, disabled, name: sessionName } = props;
  const { isPremiere, onClick } = props;
  const selectedStore = useStoresStore(store => store.selectedStore);

  const [ticketsStore] = selectedStore ?? [];
  const { vendor } = ticketsStore ?? {};
  const { id: vendorId } = vendor ?? {};

  const { name, sessions: sessionsRaw } = theaterType;
  const sortedSessions = useMemo(
    () => sessionsRaw?.sort((a, b) => sortByDate(a.showtime, b.showtime)),
    [sessionsRaw]
  );
  const sessions: SessionPartial[] | undefined = useMemo(() => {
    if (!sortedSessions) return;
    const unitCase = sortedSessions.length === 2;
    const complexCase = sortedSessions.length % 2 !== 0;
    if (sortedSessions.length === 2)
      return [...sortedSessions, { id: empty, showtime: empty }];
    if (unitCase || complexCase) {
      return [...sortedSessions, { id: empty, showtime: empty }];
    }
    return sortedSessions;
  }, [sortedSessions]);

  const premiereSessions = isPremiere
    ? sessions?.filter(item =>
        dayjs().isBefore(dayjs(item?.showtime), "minutes")
      )
    : sessions;

  const renderItem = useCallback(
    (listItem: SessionPartial, index: number) => {
      const session = listItem;
      if (session.id === empty) {
        return <div key={index} className="TheaterType__session" />;
      }

      return (
        <ScheduleSession
          key={index}
          session={session as Session}
          disabled={disabled}
          onClick={onClick}
        />
      );
    },
    [disabled, onClick]
  );

  const renderItemMemoized = useMemo(() => renderItem, [renderItem]);

  return (
    <Styles className={`TheaterType ${className}`}>
      {premiereSessions &&
      premiereSessions.length > 0 &&
      typeof vendorId !== "undefined" &&
      vendorId !== CINEMARK_TICKETS_VENDOR.id ? (
        <p className="TheaterType__type">
          {sessionName ? `${sessionName} ・` : null} {name}
        </p>
      ) : null}
      {premiereSessions?.map((item, index) => {
        return renderItemMemoized(item, index);
      })}
    </Styles>
  );
};

export default TheaterType;
